import axios from "axios";
import { getValidToken } from "../../../utils/authUtils";

export const dailyLogApi = {
  createDailyLog: async (data: any, rentalJourneyId: string) => {
    try {
      const token = await getValidToken();
      const url = `${process.env.REACT_APP_API_HOST}rental-journey-daily-logs/${rentalJourneyId}`;
      const response = await axios.post(url, data, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.data?.isSuccess) {
        return response.data?.data;
      } else {
        return null;
      }
    } catch (error) {
      console.error("Error creating daily log", error);
      return null;
    }
  },
  updateDailyLog: async (id: string, data: any) => {
    try {
      const token = await getValidToken();
      const url = `${process.env.REACT_APP_API_HOST}rental-journey-daily-logs/${id}`;
      const response = await axios.put(url, data, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.data?.isSuccess) {
        return response.data?.data;
      } else {
        return null;
      }
    } catch (error) {
      console.error("Error updating daily log", error);
      return null;
    }
  },
  getDailyLogs: async (rentalJourneyId: string) => {
    try {
      const token = await getValidToken();
      const url = `${process.env.REACT_APP_API_HOST}rental-journey-daily-logs/${rentalJourneyId}`;
      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.data?.isSuccess) {
        return response.data?.data;
      } else {
        return [];
      }
    } catch (error) {
      console.error("Error getting daily logs", error);
      return [];
    }
  },
  softDeleteDailyLog: async (rentalJourneyId: string, data: any) => {
    try {
      const token = await getValidToken();
      const url = `${process.env.REACT_APP_API_HOST}rental-journey-daily-logs/soft-delete/${rentalJourneyId}`;
      const response = await axios.post(url, data, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.data?.isSuccess) {
        return response.data?.data;
      } else {
        return null;
      }
    } catch (error) {
      console.error("Error soft deleting daily log", error);
      return null;
    }
  },
  getSoftDeletedDailyLogs: async (rentalJourneyId: string) => {
    try {
      const token = await getValidToken();
      const url = `${process.env.REACT_APP_API_HOST}rental-journey-daily-logs/deleted/${rentalJourneyId}`;
      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.data?.isSuccess) {
        return response.data?.data;
      } else {
        return [];
      }
    } catch (error) {
      console.error("Error getting soft deleted daily logs", error);
      return [];
    }
  },
};
